import { post, del, get } from 'aws-amplify/api';
import { processResponse, handleApiResponse } from './api_util';
import useSWR from 'swr';


export function useGetGroupAssignments(caseID, shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? ['GROUPASSIGNMENTS', caseID] : null,
        async (path) => {
            const response = await getGroupAssignments(caseID);
            // console.log('Response from getGroupAssignments:', JSON.stringify(response));
            return response;
        }
    );
    return result;
}

export function useGetOrgGroupAssignments(orgID, shouldFetch = true) {
    const result = useSWR(
        shouldFetch ? ['ORGGROUPASSIGNMENTS', orgID] : null,
        async (path) => {
            const response = await getOrgGroupAssignments(orgID);
            return response;
        }
    );
    return result;
}

export function useCreateGroupAssignment() {
    return async (caseID, userGroupPairs) => {
        try {
            const response = await createGroupAssignment(caseID, userGroupPairs);
            return handleApiResponse(
                ['GROUPASSIGNMENTS', caseID],
                'userID',
                response,
                'create'
            );
        } catch (error) {
            console.error('Error creating group assignment:', error);
            throw error;
        }
    };
}

export function useCreateOrgGroupAssignment() {
    return async (orgID, userGroupPairs) => {
        try {
            const response = await createOrgGroupAssignment(orgID, userGroupPairs);
            return handleApiResponse(
                ['ORGGROUPASSIGNMENTS', orgID],
                'userID',
                response,
                'create'
            );
        } catch (error) {
            console.error('Error creating group assignment:', error);
            throw error;
        }
    };
}


// Delete group assignment
export function useDeleteGroupAssignment() {
    return async (caseID, userGroupPairs) => {
        try {
            const response = await deleteGroupAssignment(caseID, userGroupPairs);
            // console.log('Response from useDeleteGroupAssignment:', JSON.stringify(response));
            return handleApiResponse(
                ['GROUPASSIGNMENTS', caseID],
                'userID',
                response,
                'delete'
        );
        } catch (error) {
            console.error('Error deleting group assignment:', error);
            throw error;
        }
    };
}

export function useDeleteOrgGroupAssignment() {
    return async (orgID, userGroupPairs) => {
        try {
            const response = await deleteOrgGroupAssignment(orgID, userGroupPairs);

            return handleApiResponse(
                ['ORGGROUPASSIGNMENTS', orgID],
                'userID',
                response,
                'delete'
        );
        } catch (error) {
            console.error('Error deleting group assignment:', error);
            throw error;
        }
    };
}

// API operations
async function getGroupAssignments(caseID) {
    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `cases/${caseID}/groups`
    };

    const restOperation = get(payload);
    const response = await restOperation.response;
    const processedResponse = processResponse(response);
    // console.log('Processed Response from getGroupAssignments:', JSON.stringify(processedResponse));
    return processedResponse;
}

async function getOrgGroupAssignments(orgID) {
    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `orgs/${orgID}/groups`
    };

    const restOperation = get(payload);
    const response = await restOperation.response;
    const processedResponse = processResponse(response);
    // console.log('Processed Response from getGroupAssignments:', JSON.stringify(processedResponse));
    return processedResponse;
}

async function createGroupAssignment(caseID, userGroupPairs) {
    const formattedUserGroupPairs = userGroupPairs.map(pair => ({
        userID: pair.userID,
        groupName: pair.groupName
    }));

    const params = {
        caseID,
        userGroupPairs: formattedUserGroupPairs
    };

    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `cases/${caseID}/groups/create`,
        options: {
            body: params
        }
    };

    const restOperation = post(payload);
    const response = await restOperation.response;
    if (!response) {
        console.error('No response from createGroupAssignment');
        return { success: true, createdAssignments: formattedUserGroupPairs };
    }
    return processResponse(response);
}

async function createOrgGroupAssignment(orgID, userGroupPairs) {
    const formattedUserGroupPairs = userGroupPairs.map(pair => ({
        userID: pair.userID,
        groupName: pair.groupName
    }));

    const params = {
        orgID,
        userGroupPairs: formattedUserGroupPairs
    };

    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `orgs/${orgID}/groups/create`,
        options: {
            body: params
        }
    };

    const restOperation = post(payload);
    const response = await restOperation.response;
    if (!response) {
        console.error('No response from createOrgGroupAssignment');
        return { success: true, createdAssignments: formattedUserGroupPairs };
    }
    return processResponse(response);
}


async function deleteGroupAssignment(caseID, userGroupPairs) {
    const formattedUserGroupPairs = userGroupPairs.map(pair => ({
        userID: pair.userID,
        groupName: pair.groupName
    }));

    const params = {
        caseID,
        userGroupPairs: formattedUserGroupPairs
    };
    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `cases/${caseID}/groups/delete`,
        options: {
            body: params
        }
    };

    const restOperation = post(payload);
    const response = await restOperation.response;
    return processResponse(response);
}

async function deleteOrgGroupAssignment(orgID, userGroupPairs) {
    const formattedUserGroupPairs = userGroupPairs.map(pair => ({
        userID: pair.userID,
        groupName: pair.groupName
    }));

    const params = {
        orgID,
        userGroupPairs: formattedUserGroupPairs
    };
    const payload = {
        apiName: 'LivisiblyGroupsAPI',
        path: `orgs/${orgID}/groups/delete`,
        options: {
            body: params
        }
    };

    const restOperation = post(payload);
    const response = await restOperation.response;
    return processResponse(response);
}